import * as React from 'react'
import HelpIcon from '../help-icon'

export interface Props {
  label?: string
  id: string
  helpText?: string
}

const ValidationLabel: React.FC<Props> = ({children, label, id, helpText}) => {
  return (
    <label className="label" htmlFor={id}>
      <div className="label__text">
        {label}
        {helpText && (
          <HelpIcon text={helpText} displayClasses="u-space-left-04" />
        )}
      </div>
      {children}
    </label>
  )
}

export default ValidationLabel
